import Model from './model';
import EngagementAgreement from './engagement_agreement';

export default class Engagement extends Model {
  static NAME = 'engagement';
  static COLLECTION_NAME = "engagements";
  static URL = '/api/v2/engagements';

  static IN_EVALUATION = 'In Evaluation';
  static NOT_PROCEEDING = 'Not Proceeding';
  static SELECTED = 'Selected';
  static WITHDREW = 'Withdrew';
  static REAPPLYING = 'Reapplying';

  static SOURCING_APPLICANTS = 'applicants';
  static SOURCING_CANDIDATES = 'candidates';
  static SOURCING_NOT_PROCEEDING = 'not_proceeding';
  static SOURCING_SUBMITTED = 'submitted';
  static SOURCING_INTERVIEWS = 'interviews';
  static SOURCING_HIRED = 'hired';

  static AWAITING_PERSONA = 'Awaiting Persona';
  static AWAITING_BASIC_INFO = 'Awaiting Basic Info';
  static AWAITING_TARGET_RATE = 'Awaiting Target Rate';
  static AWAITING_RESUME = 'Awaiting Resume';
  static AWAITING_REFERENCE = 'Awaiting Reference';
  static AWAITING_QUESTIONNAIRE = 'Awaiting Questionnaire';

  static ONGOING_STATUSES = [
    Engagement.SOURCING_APPLICANTS,
    Engagement.SOURCING_CANDIDATES,
    Engagement.SOURCING_NOT_PROCEEDING,
    Engagement.SOURCING_INTERVIEWS,
    Engagement.SOURCING_HIRED,
    Engagement.SOURCING_SUBMITTED,
  ]

  static SOURCING_DISPLAY_STATUSES = {
    [Engagement.SOURCING_APPLICANTS]: 'Applicants',
    [Engagement.SOURCING_CANDIDATES]: 'Candidates',
    [Engagement.SOURCING_NOT_PROCEEDING]: 'Not Proceeding',
    [Engagement.SOURCING_SUBMITTED]: 'Submitted',
    [Engagement.SOURCING_INTERVIEWS]: 'Interviews',
    [Engagement.SOURCING_HIRED]: 'Hired',
  }

  static REJECTED_REASONS = {
    "Fit": "I've reviewed your profile and you have great experience, but this role doesn't seem to be the right one for you. The role requirements are not a match with your profile.",
    "Experience": "I've reviewed your profile and the role requirements. Although you have great experiences and qualifications, another fellow Oomple consultant was a better match to the role requirements.",
    "Security": "Unfortunately this role requires a security screening level that you do not currently hold.",
    "Location": "This role doesn't seem to be the right one for you. The role location requirements and your location preferences don't seem to match.",
    "Rate": "I've reviewed your profile and you have a great set of skills and experiences but this opportunity does not seem to match your rate expectation, as the rate for the role is significantly lower.",
    "Closed": "",
    "Not Available": "You are not available for this opportunity.",
    "Other": "",
  };

  static DEFAULT_RATE = 20;

  static SUGGESTED_FIT = {
    poor: 'Poor',
    good: 'Good',
  }

  static SUGGESTED_FEEDBACK = {
    ['education']: 'Education',
    ['experience']: 'Experience',
    ['location']: 'Location',
    ['rate']: 'Rate',
    ['skills']: 'Skills',
  }

  static PROPOSAL_RESPONSES = {
    proceeding: 'Proceeding',
    not_proceeding: 'Not Proceeding',
  }

  static PROPOSAL_FEEDBACK = {
    ['proposed-education']: 'Education',
    ['proposed-experience']: 'Experience',
    ['proposed-location']: 'Location',
    ['proposed-rate']: 'Rate',
    ['proposed-skills']: 'Skills',
  }

  getStatus = async() => {
    const { sourcing_status, status, proposed, id } = this;
    const engagementAgreements = await EngagementAgreement.where({ engagement_id_eq: id }).all(false);

    let statusDisplay;
    let statusColor;
    let completePercentage;

    if (sourcing_status === Engagement.SOURCING_NOT_PROCEEDING) {
      statusDisplay = Engagement.NOT_PROCEEDING;
      statusColor = 'gray';
      completePercentage = 0;
    } else if (!!engagementAgreements.length) {
      if (engagementAgreements[0].company_signed){
        statusDisplay = 'Hired';
        statusColor = 'green';
        completePercentage = 100;
      } else {
        statusDisplay = 'Proceeding';
        statusColor = 'green';
        completePercentage = 70;
      }
    } else if (proposed) {
      statusDisplay = 'Candidate';
      statusColor = 'green';
      completePercentage = 80;
    } else if (
      sourcing_status === Engagement.SOURCING_SUBMITTED
      || sourcing_status === Engagement.SOURCING_INTERVIEWS
      || sourcing_status === Engagement.SOURCING_HIRED) {
      statusDisplay = 'Proceeding';
      statusColor = 'green';
      completePercentage = 70;
    } else {
      statusDisplay = status;
      if (status === Engagement.WITHDREW) {
        statusColor = 'gray';
        completePercentage = 0;
      } else if (status === Engagement.IN_EVALUATION) {
        statusColor = 'green';
        completePercentage = 50;
      } else {
        statusColor = 'yellow';
        if (status === Engagement.AWAITING_PERSONA) {
          completePercentage = 10;
        } else if (status === Engagement.AWAITING_BASIC_INFO) {
          completePercentage = 20;
        } else if (status === Engagement.AWAITING_TARGET_RATE) {
          completePercentage = 30;
        } else if (status === Engagement.AWAITING_QUESTIONNAIRE) {
          completePercentage = 40;
        } else {
          completePercentage = 0;
        }
      }
    }

    return { statusDisplay, statusColor, completePercentage };
  }
}